import { createSlice } from '@reduxjs/toolkit';

const branchSlice = createSlice({
  name: 'branch',
  initialState: {
    selectedBranchId: null,
  },
  reducers: {
    setSelectedBranchId(state, action) {
      state.selectedBranchId = action.payload;
    },
  },
});

export const { setSelectedBranchId } = branchSlice.actions;
export default branchSlice.reducer;
